import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { Register } from '../../_models/register';
import { Caller } from '../../_models/caller';
import { AlertService } from '../../_services/alert.service';
import { AccessSecurity } from '../../_models/accessSecurity';
import { ExcelServiceService } from '../../_models/excel-service.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();

  tabClicked: string = "all";
  statusText: string;
  contacts: any;
  totalContacts: any;
  ownerName: any;
  status: string;
  accountOwnerId: any;
  organizationId: any;
  accountOwners: any;
  accountOwnerContactId: any;
  successMessage: any;
  contactsErrorMessage: string;
  errorMessage: string;
  displayMsg: string;
  checkedList = [];
  loading = true;
  totalCount = 0;
  masterSelected: boolean = false;
  previousStatus = '';
  contactStatus: any = 'ALL';
  totalRecords: number;
  userDrop2: any = 'ALL';
  statusUpdate: string = 'N';
  contactInfo: any;

  constructor(private excelService: ExcelServiceService, private alertService: AlertService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals, public user: User, public register: Register, public caller: Caller, public accessSec: AccessSecurity) {
    this.g.page = "Contact";
    this.populateTabData('all', "ALL");

  }

  exportToXLSXCustomers() {
    this.excelService.exportAsExcelFile(this.contacts, 'sample');
  }

  populate(orderChange) {
    this.api.getAOContactsByStatusAndAOIdAndOrgId("1", this.user.accountOwnerId, orderChange).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.contacts = data.contactResponseList;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  updateStatus(data) {
    this.contactInfo = data;
    this.statusUpdate = 'Y';
  }

  tabChange() {
    this.checkedList = [];

    this.g.loaderDisplay = "display";
  }

  populateTabData(triggered, contactStatus) {
    this.tabClicked = triggered;
    this.contactStatus = contactStatus;
    if (!this.previousStatus) {
      this.getAOContactsByStatus(contactStatus);
    } else {
      this.rerender();
    }

  }

  getAOContactsByStatus(status) {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Contact Name / Company Name / Email / Mobile'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.contactStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.contactStatus;
        }
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getAOContactsByStatusAndAOIdAndOrgId';
        let query: any = {
          status: this.contactStatus,
          organizationId: 1,
          source: 'SHIFT',
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "ROLE_USER" || this.user.role === "DEMO_ACCOUNT") {
          query.accountOwnerId = this.user.accountOwnerId;
        }

        this.g.loaderDisplay = "display";
        this.loading = true;
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.contacts = resp.contactResponseList;
            this.totalRecords = resp.noOfRecords;
            if (this.contactStatus === 'ALL' && !query.searchString) {
              this.totalCount = resp.noOfRecords;
            }
            if (this.totalRecords == 0) {
              this.displayMsg = 'No matching records found';
            } else {
              this.displayMsg = '';
            }
            this.g.loaderDisplay = "";
            this.loading = false;
            this.contacts.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.loading = false;
              this.alertService.error('Error', err);
            });
      }
    };
  }

  selectContact(c) {
    if (!c.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.contacts.length; i++) {
      this.contacts[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.contacts.length; i++) {
      if (this.contacts[i].isSelected) {
        this.checkedList.push(this.contacts[i]['accountOwnerContactId']);
      }
    }

  }

  resetCheckedList() {
    this.checkedList = [];
    this.errorMessage = '';
  }

  editContacts(contacts) {
    let i = 0;
    let ohid;
    for (let c of contacts) {
      if (c.isSelected) {
        i = i + 1;
        ohid = c.accountOwnerContactId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/editContacts/' + ohid]);
    } else {
      this.errorMessage = "Can not edit multiple products at once. Please select one at a time";
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  changeStatus() {
    this.g.loaderDisplay = "display";
    if (this.contactInfo.status == "ACTIVE") {
      this.contactInfo.status = "IN_ACTIVE";

    } else {
      this.contactInfo.status = "ACTIVE";

    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/changeContactStatus', {
      "accountOwnerContactId": this.contactInfo.accountOwnerContactId,
      "organizationId": 1,
      "status": this.contactInfo.status
    },
      { headers: header1 }).subscribe(data => {
        this.statusUpdate = 'N';
        if (data['code'] == "200") {
          if (this.tabClicked !== 'all') {
            let index = this.contacts.indexOf(this.contactInfo);
            this.contacts.splice(index, 1);
          }
          this.rerender();
          this.alertService.success('Contact', 'Status Updated Successfully');
        } else {
          if (this.contactInfo.status == "ACTIVE") {
            this.contactInfo.status = "IN_ACTIVE";
          } else {
            this.contactInfo.status = "ACTIVE";
          }
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.statusUpdate = 'N';
        });
  }

  closepopUpRequest() {
    this.statusUpdate = 'N'
    this.populateTabData(this.tabClicked, this.contactStatus);
  }

  submitContacts() {
    this.caller.parent = "CONTACTS"
    if (this.user.role === 'ROLE_ADMIN') {
      this.router.navigate(['/admin/accountOwner']);
    } else {
      this.router.navigate(['/admin/createContacts']);

    }
  }

}
